var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57 14.1067H3.6525L5.85 13.9042C6.1575 13.8742 6.4425 13.7392 6.66 13.5217L14.955 5.22672C15.345 4.83672 15.5625 4.31922 15.5625 3.77172C15.5625 3.22422 15.345 2.70672 14.955 2.31672L14.4225 1.78422C13.6425 1.00422 12.285 1.00422 11.505 1.78422L10.4475 2.84172L3.2175 10.0717C3 10.2892 2.865 10.5742 2.8425 10.8817L2.64 13.0792C2.6175 13.3567 2.715 13.6267 2.91 13.8292C3.09 14.0092 3.3225 14.1067 3.57 14.1067ZM12.9675 2.30172C13.2075 2.30172 13.4475 2.39172 13.6275 2.57922L14.16 3.11172C14.2476 3.19786 14.3172 3.30058 14.3647 3.41389C14.4122 3.52721 14.4367 3.64885 14.4367 3.77172C14.4367 3.89459 14.4122 4.01623 14.3647 4.12955C14.3172 4.24286 14.2476 4.34558 14.16 4.43172L13.5 5.09172L11.6475 3.23922L12.3075 2.57922C12.4875 2.39922 12.7275 2.30172 12.9675 2.30172ZM3.96 10.9867C3.96 10.9417 3.9825 10.9042 4.0125 10.8742L10.845 4.03422L12.6975 5.88672L5.865 12.7192C5.865 12.7192 5.79 12.7717 5.7525 12.7717L3.78 12.9517L3.96 10.9792V10.9867ZM17.0625 16.4992C17.0625 16.8067 16.8075 17.0617 16.5 17.0617H1.5C1.1925 17.0617 0.9375 16.8067 0.9375 16.4992C0.9375 16.1917 1.1925 15.9367 1.5 15.9367H16.5C16.8075 15.9367 17.0625 16.1917 17.0625 16.4992Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-icon.c11dcee4ed2c0ffb055d8cbdf312c292.svg";
export { ForwardRef as ReactComponent };